import { StyleSheet } from 'react-native';
import Theme from 'Theme';
import { Device } from 'DeviceUtils';
import { headerTitleStyle } from '../../../runtime/Navigation/navigationOptions';

let baseStyles = StyleSheet.create({
    container: {
        // flexDirection: 'row',
        // alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: 50,
        paddingRight: 0
    },
    label: {
        color: Theme.primaryTextColor,
        ...headerTitleStyle
    }
});

if (Device.isWeb) {
    baseStyles = {
        ...baseStyles,
        container: {
            flex: 1,
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            height: 50,
            paddingRight: 60
        },
        label: {
            fontSize: 26,
            letterSpacing: 0.75,
            color: Theme.primaryTextColor,
            fontFamily: Theme.ultraFont
        }
    };
}

export default StyleSheet.create(baseStyles);
